module.exports = __webpack_public_path__ + "media/images/blog/blog_cover_placeholder-dfc2d6aac41eb73652547a1a1e4d67ba.png";